<div [formGroup]="form" *ngIf="isVisible">
  <file-uploader
    [maxSize]="1024 * 5"
    [allowedTypes]="['png', 'jpg', 'jpeg']"
    (select)="onFileSelect($event)"
    (remove)="onFileRemove()"
    class="d-block w-100"
  >
    <input
      #file
      type="file"
      class="input"
      (click)="markAsTouched('passport')"
      required
    />
    <ng-template #placeholder>
      <img
        src="assets/images/icons/upload-document.svg"
        alt="upload document icon"
      />
      <div
        class="text-primary pt-2 text-sm"
        i18n="@@support.nameTickets.passport"
      >
        Photo of the main page of your passport *
      </div>
    </ng-template>
  </file-uploader>

  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="passport?.errors?.required && passport?.touched"
    >* This field is required.</small
  >
  <form-field
    class="front textarea mb-0 mt-3"
    label="Ticket Message"
    i18n-label="@@support.message.label"
  >
    <textarea
      formControlName="message"
      placeholder="Enter your ticket message"
      rows="5"
      i18n-placeholder="@@support.message.placeholder"
    ></textarea>
  </form-field>

</div>
